import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// shadcn-standard class-name merger — lets component consumers override
// tailwind utilities without writing a custom conflict resolver each time.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
